import { FC, useState } from 'react';
import { Typography } from '@mui/material';
import { CustomButton, CustomDatePicker } from 'components/shared';
import { DATE_FORMAT } from 'utils/enums';
import { formatDateView } from 'utils/helpers';
import { RadabankService } from 'utils/services';
import { RestoreRadabankPasswordStepProps } from '../../data';
import styles from './index.module.scss';

export const RestoreRadabankPasswordBirthdayStep: FC<RestoreRadabankPasswordStepProps> = ({
	onSaveData,
	initialValues,
	onError,
	className = '',
}) => {
	const [isLoading, setIsLoading] = useState(false);
	const [birthday, setBirthday] = useState<string | null>(initialValues.birthday || null);

	const handleChangeBirthday = (value: string) => {
		setBirthday(value);
	};

	const onSubmit = async () => {
		if (!birthday) return;
		try {
			setIsLoading(true);
			const formattedBirthday = formatDateView(birthday, DATE_FORMAT.RADABANK_REQUEST);
			await RadabankService.resetPasswordBirthday({ ...initialValues, birthday: formattedBirthday });
			onSaveData?.({ ...initialValues, birthday: formattedBirthday });
		} catch (error) {
			onError(error);
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div className={className}>
			<Typography>Введіть свою дату народження</Typography>
			<CustomDatePicker
				placeholder="ДД.ММ.РРРР"
				className={styles.datepicker}
				label="Дата народження"
				value={birthday}
				onChange={handleChangeBirthday}
				disableFuture
			/>
			<CustomButton label="Продовжити" onClick={onSubmit} disabled={!birthday} isLoading={isLoading} size="large" />
		</div>
	);
};
